import { FunctionComponent } from 'preact';
import { useDetectDevice } from 'hooks';
import { PudoLocation } from '@pperform/pp-data-mappers';
import chevronDownIconSVG from 'icons/chevron-down.svg';
import chevronUpIconSVG from 'icons/chevron-up.svg';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'react-i18next';
import { addSvgAccessibility } from 'utils/svg.utils';
import {
  TitleContainer,
  DropOffName,
  CardHeader,
  IconContainer,
} from './DropOffCard.styles';
import { MapView } from '../MapView';
import { DropOffAddress } from './components/DropOffAddress';

export interface DropOffCardButtonProps {
  dropOff: PudoLocation;
  isViewOnly?: boolean;
  isShowDropoffMap?: boolean;
  expanded?: boolean;
}

const DropOffCardButton: FunctionComponent<DropOffCardButtonProps> = ({
  dropOff,
  isViewOnly = false,
  isShowDropoffMap = false,
  expanded = false,
}): JSX.Element => {
  const { t } = useTranslation();
  const { isMobile } = useDetectDevice();
  const { locationType } = dropOff.address;
  const { lat, lng } = dropOff;
  const center = { lat, lng };

  return (
    <CardHeader isFullWidth justify="space-between">
      <TitleContainer>
        {locationType && <DropOffName>{locationType}</DropOffName>}
        <DropOffAddress
          address={dropOff.address}
          coordinates={{ lat, lng }}
          variant={isViewOnly ? 'link' : 'text'}
        />
        {isMobile && isShowDropoffMap && (
          <MapView center={center} isDropOffEmpty={!dropOff} isViewOnlyMode />
        )}
      </TitleContainer>

      {!isViewOnly && (
        <IconContainer>
          {expanded ? (
            <ReactSVG
              src={chevronUpIconSVG}
              beforeInjection={addSvgAccessibility(
                t('ALT_TEXT_COLLAPSE_DROPOFF_DETAILS'),
              )}
            />
          ) : (
            <ReactSVG
              src={chevronDownIconSVG}
              beforeInjection={addSvgAccessibility(
                t('ALT_TEXT_EXPAND_DROPOFF_DETAILS'),
              )}
            />
          )}
        </IconContainer>
      )}
    </CardHeader>
  );
};

export { DropOffCardButton };
